<template>
  <b-card :title="Option.title">
    <app-echart-bar
      :option-data="option"
      ref="rp"
    />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import AppEchartBar from '@core/components/charts/echart/AppEchartBar.vue'
import { ref, reactive, watch, watchEffect, getCurrentInstance } from '@vue/composition-api'
export default {
  components: {
    BCard,
    AppEchartBar,
  },
  props: {
    Option: {
      type: Object,
      default: ()=>{
        return {
          title: 'title',
        }
      }
    },
    Data: {
      type: Array,
      default: ()=>[]
    },
  },
  setup(props, ctx) {
    const option = {
      xAxis: [
        {
          type: 'category',
          data: props.Data[0]?.data.reduce((acc, cur)=>
          {
            acc.push(cur.date)
            return acc
          }, [])
        },
      ],
      yAxis: [
        {
          type: 'value',
          splitLine: { show: false },
        },
      ],
      grid: {
        left: '40px',
        right: '30px',
        bottom: '30px',
      },
      series: props.Data.reduce((acc, cur, idx)=>
      {
        let obj = {
          name: cur.name,
          type: 'bar',
          stack: 'advertising',
          data: cur.data.reduce((acc2, cur2)=>{acc2.push(cur2.value); return acc2;}, []),
          barMaxWidth: '20%',
          barMinWidth: '10px',
        }
        if(idx === props.Data.length - 1){
          obj["itemStyle"] = {
            barBorderRadius: [10, 10, 0, 0],
          }
        }
        acc.push(obj)

        return acc
      }, [])
    }
    const vue = getCurrentInstance()
    ctx.emit('chartUpdate', ()=>{
      option.series = props.Data.reduce((acc, cur, idx)=>
      {
        let obj = {
          name: cur.name,
          type: 'bar',
          stack: 'advertising',
          data: cur.data.reduce((acc2, cur2)=>{acc2.push(cur2.value); return acc2;}, []),
          barMaxWidth: '20%',
          barMinWidth: '10px',
        }
        if(idx === props.Data.length - 1){
          obj["itemStyle"] = {
            barBorderRadius: [10, 10, 0, 0],
          }
        }
        acc.push(obj)

        return acc
      }, [])
      option.xAxis = [
        {
          type: 'category',
          data: props.Data[0]?.data.reduce((acc, cur)=>
          {
            acc.push(cur.date)
            return acc
          }, [])
        },
      ]
      vue.refs.rp?.$children[0].mergeOptions(option, false)
    })

    return {
      option
    }
  },
}
</script>
